import { render, staticRenderFns } from "./UserOrder.vue?vue&type=template&id=0e2e51f9&"
import script from "./UserOrder.vue?vue&type=script&lang=js&"
export * from "./UserOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports